import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  sendMessage,
  queryMessageBySessionId,
  editMessage,
  readMessage,
  queryMessageWidgetByRequesterId,
  sendMessageWidget,
} from "./thunkAction";

const initialState = {
  messages: [],
  message: {},
  total: 0,
  skip: 0,
  limit: 10,
  loading: false,
  error: null,
  sessionId: null,
  isLoadingSendMessage: false,
  errorSendMessage: null,
  isLoadingQueryMessage: false,
  errorQueryMessage: null,
};

const messageSlice = createSlice({
  name: "messageManage",
  initialState,
  reducers: {
    clearMessage(state) {
      state.messages = [];
      state.message = {};
      state.total = 0;
      state.skip = 0;
      state.limit = 10;
    },
    resetSendMessageError(state) {
      state.errorSendMessage = null;
    },
    setLimit(state, action) {
      state.limit = _.get(action, "payload", 10);
    },
    setSkip(state, action) {
      state.skip = _.get(action, "payload", 0);
    },
    addMessage(state, action) {
      const message = _.get(action, "payload");

      const sessionId = _.get(message, "sessionId");
      const messageId = _.get(message, "_id");
      const isDuplicate = _.some(
        state.messages,
        (message) => _.get(message, "_id") === messageId
      );

      if (state.sessionId === sessionId && !isDuplicate) {
        state.messages.push(message);
        state.total++;
      }
    },
    setSessionId(state, action) {
      const sessionId = _.get(action, "payload", null);
      if (sessionId) {
        state.sessionId = sessionId;
      }
    },
    addReplyMessage(state, action) {
      const message = _.get(action, "payload", null);
      const messageId = _.get(message, "_id");
      if (messageId) {
        state.message[messageId] = message;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // queryMessageBySessionId
      .addCase(queryMessageBySessionId.pending, (state) => {
        state.isLoadingQueryMessage = true;
      })
      .addCase(queryMessageBySessionId.fulfilled, (state, action) => {
        state.errorQueryMessage = null;
        state.isLoadingQueryMessage = false;
        const data = _.get(action, "payload", {});
        const messages = _.get(data, "data", []);
        state.total = _.get(data, "metadata.total", 0);

        const mergedMessages = [...messages, ...state.messages];
        const uniqueMessages = _.uniqBy(mergedMessages, "_id");
        state.messages = _.sortBy(uniqueMessages, "addTime");
      })
      .addCase(queryMessageBySessionId.rejected, (state, action) => {
        state.isLoadingQueryMessage = false;
        state.errorQueryMessage = action.payload;
      })
      // queryMessageWidgetByRequesterId
      .addCase(queryMessageWidgetByRequesterId.pending, (state) => {
        state.isLoadingQueryMessage = true;
      })
      .addCase(queryMessageWidgetByRequesterId.fulfilled, (state, action) => {
        state.errorQueryMessage = null;
        state.isLoadingQueryMessage = false;
        const data = _.get(action, "payload", {});
        const messages = _.get(data, "data", []);
        state.total = _.get(data, "metadata.total", 0);

        const mergedMessages = [...messages, ...state.messages];
        const uniqueMessages = _.uniqBy(mergedMessages, "_id");
        state.messages = _.sortBy(uniqueMessages, "addTime");
      })
      .addCase(queryMessageWidgetByRequesterId.rejected, (state, action) => {
        state.isLoadingQueryMessage = false;
        state.errorQueryMessage = action.payload;
      })
      // sendMessage
      .addCase(sendMessage.pending, (state) => {
        state.isLoadingSendMessage = true;
        state.errorSendMessage = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.isLoadingSendMessage = false;
        const message = _.get(action, "payload", {});
        if (message._id) {
          state.messages.push(message);
        }
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.isLoadingSendMessage = false;
        state.errorSendMessage = action.payload;
      })
      // sendMessageWidget
      .addCase(sendMessageWidget.pending, (state) => {
        state.isLoadingSendMessage = true;
        state.errorSendMessage = null;
      })
      .addCase(sendMessageWidget.fulfilled, (state, action) => {
        state.isLoadingSendMessage = false;
        const message = _.get(action, "payload", {});
        if (message._id) {
          state.messages.push(message);
        }
      })
      .addCase(sendMessageWidget.rejected, (state, action) => {
        state.isLoadingSendMessage = false;
        state.errorSendMessage = action.payload;
      })
      // editMessage
      .addCase(editMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(editMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // readMessage
      .addCase(readMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(readMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.loading = false;
        const message = _.get(action, "payload", null);
        const messageId = _.get(message, "_id");
        if (messageId) {
          state.message[messageId] = message;
        }
      })
      .addCase(readMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const messageReducer = messageSlice.reducer;

export const messageAction = messageSlice.actions;
